import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Text,
  useToast,
} from '@chakra-ui/react';
import { supabase } from '../supabaseClient';

const CreateGroupModal = ({ isOpen, onClose, onGroupCreated }) => {
  const [groupName, setGroupName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const handleCreateGroup = async () => {
    try {
      setIsLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('No authenticated user');

      // Check if group name already exists
      const { data: existingGroup } = await supabase
        .from('member_groups')
        .select('id')
        .eq('name', groupName.trim())
        .single();

      if (existingGroup) {
        toast({
          title: 'Group already exists',
          description: 'Please choose a different name',
          status: 'error',
          duration: 3000,
        });
        return;
      }

      const { error } = await supabase
        .from('member_groups')
        .insert([{ 
          name: groupName.trim(),
          created_by: user.id
        }]);

      if (error) throw error;

      setGroupName('');
      onClose();
      onGroupCreated();
    } catch (error) {
      console.error('Error creating group:', error);
      toast({
        title: 'Error creating group',
        description: error.message,
        status: 'error',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create New Group</ModalHeader>
        <ModalBody>
          <Text mb={4}>
            Create a new group to organize and manage members more effectively.
          </Text>
          <Input
            placeholder="Enter group name"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={handleCreateGroup}
            isLoading={isLoading}
            isDisabled={!groupName.trim()}
          >
            Create Group
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateGroupModal;
